export default __webpack_public_path__ + "static/media/fhm-tour.936a9965.webp";